import React from 'react';
import './PartyPackageCard.css';


const PartyPackageCard = ({data}) => {

    return (
        <div className="ppck-food-card">
            <div className="ppck-food-image-section ppck-shimmer-bg">

                <div className="ppck-shimmer-bg">
                    <div className="bid-info ppck-shimmer-bg">
                        <p className="price ppck-shimmer-bg"></p>
                    </div>
                    <div className="offer-time ppck-shimmer-bg">
                        <p></p>
                        <p className="time-left ppck-shimmer-bg"></p>
                    </div>
                </div>
            </div>

            <div className="food-details ">
                <div className='ppck-food-name ppck-shimmer-bg'>
                    <h3></h3>
                    <span className='f-rating ppck-shimmer-bg'></span>
                </div>
                <div className="ppck-venue ppck-shimmer-bg">
                    <div className='v-logo ppck-shimmer-bg'>
                       
                    </div>
                    <div>
                        <span className="f-rating ppck-shimmer-bg"></span>
                    </div>
                </div>
                <p className="address ppck-shimmer-bg"></p>
                <p className="timing ppck-shimmer-bg">
                   
                </p>
                <div className="ppck-footer-row ppck-shimmer-bg">
                    <a href="#" className="details-link ppck-shimmer-bg"></a>
                </div>
            </div>
        </div>
    );
};

export default PartyPackageCard;
